// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.program-name {
  font-size: 13px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
  word-break: break-word;
  text-align: justify;
  margin-bottom: 4px;
  overflow-wrap: anywhere;
}

@media (max-width: 576px) {
  .program-name {
    font-size: 12px;
    line-height: 1.3;
    text-align: left;
  }
}

@media (min-width: 577px) and (max-width: 992px) {
  .program-name {
    font-size: 13px;
    line-height: 1.4;
  }
}

@media (min-width: 993px) {
  .program-name {
    font-size: 14px;
    line-height: 1.5;
  }
}

.card-disabled {
  opacity: 0.60;
  pointer-events: none;
  cursor: not-allowed;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

/* === Card top row layout === */
.tech-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.tech-card-icon {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 15px;
  padding: 8px;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.tech-card-icon img {
  width: 50px;
  height: 50px;
  max-width: 100%;
  max-height: 100%;
}

.tech-card-info {
  flex-grow: 1;
  min-width: 0;
}

.tech-card-info h6 {
  font-size: 14px;
  line-height: 1.2;
}

.tech-card-seats {
  background-color: rgba(0, 0, 0, 0.30);
  border-radius: 10px;
  padding: 6px 10px;
  min-width: 95px;
  text-align: center;
  flex-shrink: 0;
}

/* === Small screens (mobile) === */
@media (max-width: 576px) {
  .tech-card-top {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }

  .tech-card-icon {
    width: 56px;
    height: 56px;
  }

  .tech-card-icon img {
    width: 40px;
    height: 40px;
  }

  .tech-card-info {
    flex-basis: 100%;
    order: 3;
    text-align: center;
  }

  .tech-card-info h6 {
    font-size: 13px;
  }

  .tech-card-seats {
    min-width: 80px;
    padding: 5px 8px;
  }
}

/* === Medium screens (tablets) === */
@media (min-width: 577px) and (max-width: 992px) {
  .tech-card-icon {
    width: 60px;
    height: 60px;
  }

  .tech-card-icon img {
    width: 44px;
    height: 44px;
  }

  .tech-card-seats {
    min-width: 85px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CoursePayments/technologyCards.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".program-name {\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  word-break: break-word;\r\n  text-align: justify;\r\n  margin-bottom: 4px;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .program-name {\r\n    font-size: 12px;\r\n    line-height: 1.3;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n@media (min-width: 577px) and (max-width: 992px) {\r\n  .program-name {\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n  }\r\n}\r\n\r\n@media (min-width: 993px) {\r\n  .program-name {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n.card-disabled {\r\n  opacity: 0.60;\r\n  pointer-events: none;\r\n  cursor: not-allowed;\r\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* === Card top row layout === */\r\n.tech-card-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.tech-card-icon {\r\n  background-color: rgba(255, 255, 255, 0.15);\r\n  border-radius: 15px;\r\n  padding: 8px;\r\n  width: 70px;\r\n  height: 70px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.tech-card-icon img {\r\n  width: 50px;\r\n  height: 50px;\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n}\r\n\r\n.tech-card-info {\r\n  flex-grow: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.tech-card-info h6 {\r\n  font-size: 14px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.tech-card-seats {\r\n  background-color: rgba(0, 0, 0, 0.30);\r\n  border-radius: 10px;\r\n  padding: 6px 10px;\r\n  min-width: 95px;\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* === Small screens (mobile) === */\r\n@media (max-width: 576px) {\r\n  .tech-card-top {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n\r\n  .tech-card-icon {\r\n    width: 56px;\r\n    height: 56px;\r\n  }\r\n\r\n  .tech-card-icon img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .tech-card-info {\r\n    flex-basis: 100%;\r\n    order: 3;\r\n    text-align: center;\r\n  }\r\n\r\n  .tech-card-info h6 {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .tech-card-seats {\r\n    min-width: 80px;\r\n    padding: 5px 8px;\r\n  }\r\n}\r\n\r\n/* === Medium screens (tablets) === */\r\n@media (min-width: 577px) and (max-width: 992px) {\r\n  .tech-card-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n  }\r\n\r\n  .tech-card-icon img {\r\n    width: 44px;\r\n    height: 44px;\r\n  }\r\n\r\n  .tech-card-seats {\r\n    min-width: 85px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
